import styled from '@emotion/styled';
import { initI18n } from '@peritasai/i18n-shared';
import { getAnalyticsConfig, initAnalytics } from '@peritasai/analytics';
import {
  initSupportLogging,
  wireGlobalErrorHandlers,
  SupportErrorBoundary,
} from '@peritasai/support-logging';
import { postSupportLogs, postSupportLogsBeacon } from '@peritasai/data-access';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import { initializeFederation } from './app/utils/init-mf';
import { renderFatalError } from './app/utils/render-fatal-error';
import './styles.css';

console.log('periverse: @emotion/styled', styled);

async function bootstrap() {
  try {
    await initializeFederation(); // Await dynamic initialization

    await initI18n({
      appName: 'periverse',
      supportedLngs: ['en', 'es'],
      ns: [
        'common',
        'periverse',
        'peri-track',
        'peri-tray',
        'oem-tray',
        'peri-theatre',
      ],
      debug: import.meta.env.DEV, // Enable debug in development
    });

    try {
      initAnalytics(getAnalyticsConfig('periverse'));
    } catch (error) {
      console.warn('Analytics initialization failed:', error);
    }

    try {
      initSupportLogging({
        intervalMs: 10000,
        postFn: postSupportLogs,
        postBeaconFn: postSupportLogsBeacon,
      });

      wireGlobalErrorHandlers({
        serviceName: 'periverse_app',
        source: 'periverse',
      });
    } catch (error) {
      console.warn('Support logging initialization failed:', error);
    }

    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );

    root.render(
      <StrictMode>
        <SupportErrorBoundary source="periverse">
          <App />
        </SupportErrorBoundary>
      </StrictMode>
    );
  } catch (error) {
    console.error('🔴 MF INIT: Fatal error during startup:', error);
    renderFatalError('root', (error as Error).message);
  }
}

bootstrap();
